
import { Treatment, PracticeLocation, SiteSettings } from './types';

export const INITIAL_CATEGORIES: string[] = [
  'Consultatie',
  'Spierontspanners (Botox)',
  'Fillers',
  'Bio remodulering',
  'Draadjeslift APTOS',
  'Cellulite & Lichaamsverbetering',
  'Cellboosters',
  'CO2 Laser',
  'Laser',
  'Microneedling',
  'Lipolyse',
  'Handen',
  'Tandenknarsen',
  'Transpiratie',
  'Haarverlies',
  'Chirurgie',
  'Oplossen Filler',
  'Hydrafacial',
  'Diversen'
];

const DEFAULT_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766744175/MD_and_patient_froq58.png';
const BODY_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766744175/MD_and_patient_froq58.png';
const LASER_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766744175/MD_and_patient_froq58.png';
const BOTOX_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766237584/Botox_voorhoofd_zjnarp.png';
const CONSULT_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766438414/onderzoek_patient1_fktwnj.png';
const TRAANGOOT_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766237535/traangoot_fillers_sec5ny.png';
const CO2_EYE_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766439303/co2laser1_kvnuza.png';
const LIP_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766657852/Lipfillers_f4g130.png';
const NOSE_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766658083/Fillers_neuscorrectie_w7qo4h.png';
const FILLER_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766658236/Hyaluronic_acid_face1_iw8sv1.png';
const APTOS_JAW_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766238407/Draadjesliftkaak1_gcwd3o.png';
const SHOCKWAVE_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766691947/shockwave1_omxczb.png';
const APTOS_NECK_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766692736/Draadjeslift_nek_lzkies.png';
const APTOS_CHEEK_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766692738/Draadjesliftkaak%C3%A9_mybzqr.png';
const APTOS_FULL_FACE_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766692738/draadjeslift_wang_xixrhs.png';
const APTOS_BODY_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766693409/Draadjeslift_body_vxakzh.png';
const APTOS_NASOLABIAL_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766693553/draadjeslift_neuslip_y45j4z.png';
const PROFHILO_BODY_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766743017/Filler_arm1_llwpsd.png';
const LANLUMA_FACE_IMAGE = 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766743293/Filler_cheeks1_unnevx.png';

export const INITIAL_TREATMENTS: Treatment[] = [
  // Consultatie
  {
    id: 'consult-1',
    name: 'Medische consultatie (RIZIV)',
    category: 'Consultatie',
    description: 'Een uitgebreid intakegesprek om uw wensen en medische achtergrond te bespreken.',
    price: '50',
    duration: '30 min',
    recovery: 'Geen',
    visibility: 'Direct',
    details: 'Een succesvolle esthetische behandeling begint altijd met een grondige analyse. Tijdens deze medische consultatie bespreekt Dr. An De Cuyper uw wensen, analyseert ze uw gelaatsanatomie en huidkwaliteit, en stelt ze een persoonlijk behandelplan op. Er wordt gekeken naar de medische haalbaarheid en u krijgt eerlijk advies over de te verwachten resultaten.',
    benefits: ['Diepgaande gelaatsanalyse', 'Medisch advies op maat', 'Transparante kostenraming', 'Gelegenheid tot vragen stellen'],
    process: [
      { step: 1, title: 'Anamnese', description: 'Bespreking van uw medische geschiedenis en specifieke wensen.' },
      { step: 2, title: 'Analyse', description: 'Inspectie van de huidkwaliteit, botstructuur en spieractiviteit.' },
      { step: 3, title: 'Behandelplan', description: 'Opstellen van een persoonlijk plan met bijhorende prijsofferte.' }
    ],
    faqs: [
      { question: 'Is een consultatie verplicht?', answer: 'Ja, voor nieuwe patiënten of nieuwe behandelingen is een consultatie essentieel om de veiligheid en kwaliteit te waarborgen.' },
      { question: 'Wordt de consultatie terugbetaald?', answer: 'Omdat het gaat om een medische consultatie door een arts, is er gedeeltelijke terugbetaling via het RIZIV mogelijk, afhankelijk van de aard van het consult.' }
    ],
    imageUrl: CONSULT_IMAGE,
    detailImageUrl: CONSULT_IMAGE
  },
  
  // Spierontspanners (Botox)
  {
    id: 'botox-1',
    name: '1 spuitje / zone',
    category: 'Spierontspanners (Botox)',
    description: 'Behandeling van één zone met spierontspanners voor een frisse, ontspannen uitstraling.',
    price: '120',
    duration: '15 min',
    recovery: 'Geen',
    visibility: '3-4 maanden',
    details: 'Spierontspanners (Botuline Toxine) worden gebruikt om dynamische rimpels te verminderen die ontstaan door spieractiviteit, zoals fronsrimpels, voorhoofdslijnen of kraaienpootjes. Het doel is niet om het gezicht stil te leggen, maar om een uitgeruste en vriendelijke uitstraling te creëren door de spierspanning te verlagen.',
    benefits: ['Verzacht rimpels zichtbaar', 'Voorkomt verdieping van lijnen', 'Natuurlijke, uitgeruste blik', 'Snelle behandeling zonder downtime'],
    process: [
      { step: 1, title: 'Markering', description: 'De arts vraagt u om te fronsen of te lachen om de spieractiviteit in kaart te brengen.' },
      { step: 2, title: 'Injectie', description: 'Met een zeer fijn naaldje wordt de spierontspanner nauwkeurig in de spier geïnjecteerd.' },
      { step: 3, title: 'Resultaat', description: 'Het effect treedt geleidelijk op na 3-5 dagen en is maximaal na 2 weken.' }
    ],
    faqs: [
      { question: 'Doet de behandeling pijn?', answer: 'De meeste patiënten ervaren slechts een klein prikje, vergelijkbaar met een muggenbeet.' },
      { question: 'Krijg ik een maskergezicht?', answer: 'Nee, Dr. An De Cuyper streeft naar een natuurlijk resultaat waarbij uw normale mimiek behouden blijft.' }
    ],
    imageUrl: BOTOX_IMAGE,
    detailImageUrl: BOTOX_IMAGE
  },
  {
    id: 'botox-2',
    name: '2 spuitjes / zones',
    category: 'Spierontspanners (Botox)',
    description: 'Behandeling van twee zones, bijvoorbeeld frons en voorhoofd, voor een harmonieus resultaat.',
    price: '220',
    duration: '20 min',
    recovery: 'Geen',
    visibility: '3-4 maanden',
    details: 'Het combineren van twee zones, vaak de fronsrimpel en het voorhoofd, zorgt voor een betere balans in het bovenste gelaat. Door deze spiergroepen samen te behandelen, wordt voorkomen dat de ene spiergroep gaat compenseren voor de andere, wat zorgt voor een gladder en rustiger geheel.',
    benefits: ['Harmonieus resultaat in boven gelaat', 'Voordeliger dan losse zones', 'Preventieve werking tegen diepe groeven'],
    process: [],
    faqs: [],
    imageUrl: BOTOX_IMAGE,
    detailImageUrl: BOTOX_IMAGE
  },
  {
    id: 'botox-3',
    name: '3 spuitjes / zones',
    category: 'Spierontspanners (Botox)',
    description: 'Complete behandeling van frons, voorhoofd en kraaienpootjes.',
    price: '320',
    duration: '25 min',
    recovery: 'Geen',
    visibility: '3-4 maanden',
    details: 'Dit is de meest complete behandeling voor het bovenste gelaat. We behandelen de fronsrimpels, de dwarse voorhoofdslijnen en de kraaienpootjes rond de ogen. Dit geeft een algeheel verjongend en "open" effect aan de blik, ideaal voor wie er minder vermoeid uit wil zien.',
    benefits: ['Volledige verfrissing van de blik', 'Optimale balans in spieractiviteit', 'Open uitstraling van de ogen'],
    process: [],
    faqs: [],
    imageUrl: BOTOX_IMAGE,
    detailImageUrl: BOTOX_IMAGE
  },

  // Fillers
  {
    id: 'filler-1',
    name: 'Eerste ml Hyaluronzuur',
    category: 'Fillers',
    description: 'Volumeherstel en contourverbetering met hoogwaardig hyaluronzuur.',
    price: '280',
    duration: '30 min',
    recovery: '1-2 dagen',
    visibility: '6-12 maanden',
    details: 'Naarmate we ouder worden, verliest ons gezicht volume (vet en bot) en elasticiteit. Hyaluronzuur fillers vullen dit verlies op een natuurlijke manier weer aan. Ze kunnen gebruikt worden voor het verzachten van de neuslippenplooi, het liften van de mondhoeken, of het accentueren van de jukbeenderen.',
    benefits: ['Direct zichtbaar resultaat', 'Herstelt verloren volume', 'Hydrateert de huid van binnenuit', 'Volledig afbreekbaar en veilig'],
    process: [
      { step: 1, title: 'Keuze Filler', description: 'De juiste dikte van de filler wordt gekozen afhankelijk van de te behandelen zone.' },
      { step: 2, title: 'Behandeling', description: 'De filler wordt met een naald of canule (stompe naald) ingebracht.' },
      { step: 3, title: 'Controle', description: 'Direct na de behandeling ziet u resultaat, hoewel er lichte zwelling kan zijn.' }
    ],
    faqs: [
      { question: 'Is het resultaat blijvend?', answer: 'Nee, hyaluronzuur wordt door het lichaam langzaam afgebroken. Het effect blijft gemiddeld 6 tot 12 maanden zichtbaar.' },
      { question: 'Wat is het verschil met Botox?', answer: 'Botox ontspant spieren (tegen mimiekrimpels), fillers vullen volume op (tegen statische rimpels en volumeverlies).' }
    ],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'filler-2',
    name: 'Volgende ml Filler',
    category: 'Fillers',
    description: 'Gereduceerd tarief voor extra volume tijdens dezelfde sessie.',
    price: '220',
    duration: '15 min',
    recovery: '1-2 dagen',
    visibility: '6-12 maanden',
    details: 'Vaak is er voor een optimaal resultaat ("Full Face Approach") meer dan 1 ml nodig. Wanneer u meerdere milliliters nodig heeft tijdens dezelfde behandeling, wordt voor de vervolgspuiten een gereduceerd tarief gerekend.',
    benefits: ['Kostenefficiënt voor grotere correcties', 'Mogelijkheid tot liquid facelift'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'filler-3',
    name: 'Fullface Approach',
    category: 'Fillers',
    description: 'Holistische gelaatsverjonging waarbij het hele gezicht in balans wordt gebracht.',
    price: 'Te bespreken',
    duration: '60 min',
    recovery: '2-3 dagen',
    visibility: '12-18 maanden',
    details: 'Bij een Full Face behandeling staren we ons niet blind op één rimpel, maar kijken we naar de oorzaak van veroudering in het hele gelaat. Door strategisch volume te plaatsen op jukbeenderen, slapen, kaaklijn en kin, wordt een liftend effect gecreëerd dat er vaak natuurlijker uitziet dan het lokaal opvullen van plooien.',
    benefits: ['Natuurlijkste resultaat', 'Liftend effect zonder chirurgie', 'Herstel van jeugdige V-vorm'],
    process: [
      { step: 1, title: 'Mapping', description: 'Het gezicht wordt in kaart gebracht om volumeverlies te identificeren.' },
      { step: 2, title: 'Opbouw', description: 'We werken van boven naar beneden om de structuur van het gezicht te herstellen.' }
    ],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'filler-4',
    name: 'Traangootbehandeling',
    category: 'Fillers',
    description: 'Specialistische behandeling voor diepe wallen en donkere kringen.',
    price: '300',
    duration: '30 min',
    recovery: '1-3 dagen',
    visibility: '9-12 maanden',
    details: 'Diepte onder de ogen (de traangoot) kan zorgen voor een vermoeide uitstraling, zelfs als u goed geslapen heeft. Met een specifieke filler voor de ogen wordt dit volumetekort voorzichtig opgevuld, waardoor de schaduw verdwijnt en u er direct frisser uitziet. Dit is een geavanceerde behandeling die veel precisie vereist.',
    benefits: ['Frissere, uitgeruste blik', 'Minder schaduw onder de ogen', 'Direct resultaat'],
    process: [
      { step: 1, title: 'Veiligheid', description: 'Er wordt gebruik gemaakt van een canule (stompe naald) om bloeduitstortingen te minimaliseren.' },
      { step: 2, title: 'Injectie', description: 'De filler wordt diep onder de oogspier geplaatst voor een natuurlijk resultaat.' }
    ],
    faqs: [
      { question: 'Is het gevaarlijk rond de ogen?', answer: 'In ervaren handen is dit veilig. Dr. De Cuyper gebruikt technieken die het risico op complicaties minimaliseren.' }
    ],
    imageUrl: TRAANGOOT_IMAGE,
    detailImageUrl: TRAANGOOT_IMAGE
  },
  {
    id: 'filler-nose',
    name: 'Niet-chirurgische Neuscorrectie (Liquid Rhinoplasty)',
    category: 'Fillers',
    description: 'Correctie van de neusvorm met fillers zonder operatie.',
    price: '300',
    duration: '30 min',
    recovery: '1-2 dagen',
    visibility: '9-12 maanden',
    details: 'Een liquid rhinoplasty is een niet-chirurgische behandeling om de vorm van de neus te corrigeren met hyaluronzuur fillers. Kleine onregelmatigheden zoals een bobbel op de neusbrug, een hangende neuspunt of asymmetrie kunnen hiermee subtiel worden weggewerkt. Het resultaat is direct zichtbaar en geeft een harmonieuzer profiel zonder de lange hersteltijd van een operatie.',
    benefits: ['Rechte neusrug', 'Lift van de neuspunt', 'Geen operatie of narcose', 'Direct resultaat', 'Korte hersteltijd'],
    process: [
      { step: 1, title: 'Analyse', description: 'Dr. De Cuyper bekijkt de neus in verhouding tot de rest van het gelaat (profiel).' },
      { step: 2, title: 'Behandeling', description: 'Met een fijne naald of canule wordt de filler op strategische punten ingespoten.' },
      { step: 3, title: 'Resultaat', description: 'De neus oogt direct rechter en harmonieuzer.' }
    ],
    faqs: [
      { question: 'Is het resultaat permanent?', answer: 'Nee, de filler wordt na verloop van tijd afgebroken (9-12 maanden). Voor een blijvend effect zijn onderhoudsbehandelingen nodig.' },
      { question: 'Is het pijnlijk?', answer: 'De behandeling is niet pijnloos, maar door de verdoving in de filler is het goed te verdragen.' }
    ],
    imageUrl: NOSE_IMAGE,
    detailImageUrl: NOSE_IMAGE
  },
  {
    id: 'filler-6',
    name: 'Radiesse',
    category: 'Fillers',
    description: 'Krachtige collageenstimulator voor lifting en contourverbetering.',
    price: '350',
    duration: '30 min',
    recovery: '2-3 dagen',
    visibility: '12+ maanden',
    details: 'Radiesse is geen gewone filler, maar een calcium-hydroxylapatiet gel die niet alleen direct volume geeft, maar ook de eigen collageenproductie van het lichaam stimuleert. Het resultaat is niet alleen meer volume, maar ook een stevigere, compactere huid op lange termijn. Uitermate geschikt voor kaaklijnverstrakking en handen.',
    benefits: ['Direct volume én huidverbetering', 'Stimuleert eigen collageen', 'Langdurig resultaat (1 jaar of langer)', 'Sterk liftend vermogen'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'filler-7',
    name: 'Lipfillers (Juvederm)',
    category: 'Fillers',
    description: 'Subtiele lipvergroting of accentuering van de lipcontouren.',
    price: '300',
    duration: '30 min',
    recovery: '2-3 dagen',
    visibility: '6-9 maanden',
    details: 'Mooie lippen gaan over verhoudingen, niet alleen over volume. Met premium fillers van Juvederm kunnen we asymmetrie corrigeren, de contouren (cupidoboog) verscherpen, of volume toevoegen voor een vollere look. De focus ligt altijd op een resultaat dat past bij uw gezicht, zonder het "duck face" effect.',
    benefits: ['Herstel van lipvolume', 'Verbetering van symmetrie', 'Hydratatie van de lippen', 'Accentueren van de cupidoboog'],
    process: [
      { step: 1, title: 'Verdoving', description: 'De lippen worden lokaal verdoofd (crème of tandartsenverdoving) voor maximaal comfort.' },
      { step: 2, title: 'Vormgeving', description: 'De filler wordt nauwkeurig geplaatst om de gewenste vorm te creëren.' }
    ],
    faqs: [
      { question: 'Doet lipfillers pijn?', answer: 'De lippen zijn gevoelig, maar dankzij de verdoving is de behandeling goed te verdragen.' },
      { question: 'Hoe lang blijven mijn lippen dik?', answer: 'De eerste 48 uur is er vaak zwelling. Het eindresultaat is zichtbaar na ongeveer 2 weken.' }
    ],
    imageUrl: LIP_IMAGE,
    detailImageUrl: LIP_IMAGE
  },
  {
    id: 'filler-hybrid',
    name: 'Hybride Filler (HArmonyCa)',
    category: 'Fillers',
    description: 'Directe lifting én langdurige collageenstimulatie in één behandeling.',
    price: '500',
    duration: '45 min',
    recovery: '3-5 dagen',
    visibility: '18 - 24 maanden',
    details: 'De hybride filler is een revolutionaire behandeling die twee actieve ingrediënten combineert: hyaluronzuur voor direct volume en een liftend effect, en calciumhydroxyapatiet om de eigen collageenaanmaak krachtig te stimuleren. Dit zorgt niet alleen voor contourverbetering, maar maakt de huid op termijn ook steviger en strakker. Ideaal voor de zijkant van het gelaat en de kaaklijn.',
    benefits: ['Direct volume en lift', 'Langdurige collageenstimulatie', 'Verstrakking van de huid', 'Natuurlijk resultaat'],
    process: [
      { step: 1, title: 'Assessment', description: 'Beoordeling van de huidverslapping en volumeverlies.' },
      { step: 2, title: 'Behandeling', description: 'Inbrengen van de filler met een canule in de diepere huidlagen.' },
      { step: 3, title: 'Werking', description: 'Direct resultaat door hyaluronzuur, gevolgd door collageenopbouw in de maanden erna.' }
    ],
    faqs: [
      { question: 'Voor wie is dit geschikt?', answer: 'Vooral voor patiënten die last hebben van huidverslapping aan de zijkant van het gezicht en de kaaklijn.' }
    ],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },

  // Bio Remodulering
  {
    id: 'bio-1',
    name: 'Profhilo (2ml)',
    category: 'Bio remodulering',
    description: 'De ultieme anti-aging behandeling voor huidverslapping zonder volume toe te voegen.',
    price: '275',
    duration: '30 min',
    recovery: '1 dag',
    visibility: '6 maanden',
    details: 'Profhilo is een baanbrekende behandeling op basis van ultrazuiver hyaluronzuur. In tegenstelling tot fillers, vult het geen rimpels op, maar verspreidt het zich onder de huid om de aanmaak van collageen en elastine te stimuleren. Het resultaat is een strakkere, gehydrateerde huid met een prachtige "glow".',
    benefits: ['Pakt huidverslapping aan', 'Geen verandering van gezichtsvorm', 'Diepe hydratatie', 'Natuurlijke verjonging'],
    process: [
      { step: 1, title: 'BAP-techniek', description: 'Er worden 5 strategische injectiepunten per gezichtshelft bepaald (Bio Aesthetic Points).' },
      { step: 2, title: 'Injectie', description: 'De Profhilo wordt net onder de huid ingespoten.' },
      { step: 3, title: 'Verspreiding', description: 'Het product verspreidt zich vanzelf en begint de huid te stimuleren.' }
    ],
    faqs: [
      { question: 'Hoeveel behandelingen heb ik nodig?', answer: 'Voor een optimaal resultaat wordt een startkuur van 2 behandelingen met 4 weken tussenpoos aangeraden.' }
    ],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'bio-2',
    name: 'Profhilo opstartkuur (2 sessies)',
    category: 'Bio remodulering',
    description: 'Compleet pakket voor de start van uw Profhilo traject.',
    price: '500',
    duration: '2x 30 min',
    recovery: '1 dag',
    visibility: '6 maanden',
    details: 'Om de biologische processen in de huid maximaal te activeren, zijn twee behandelingen noodzakelijk. Dit pakket biedt de volledige kuur aan een voordeliger tarief. De tweede sessie vindt plaats 4 weken na de eerste.',
    benefits: ['Maximale collageenstimulatie', 'Langduriger resultaat', 'Voordelige pakketprijs'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'bio-expander',
    name: 'Bioexpander (2ml)',
    category: 'Bio remodulering',
    description: 'Bio-volumetrische verjonging die volume combineert met diepe hydratatie.',
    price: '250',
    duration: '30 min',
    recovery: '1-2 dagen',
    visibility: 'Direct',
    details: 'Bioexpander (Regenyal) is een uniek hyaluronzuur dat zich perfect integreert in de huid. Het geeft een subtiel volume (bijvoorbeeld in de wangen) en verbetert tegelijkertijd de elasticiteit en hydratatie van de huid drastisch. Ideaal voor de zijkant van het gelaat en de kaaklijn.',
    benefits: ['Subtiel volume', 'Extreme hydratatie', 'Natuurlijke integratie'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'bio-profhilo-body',
    name: 'Profhilo Body (2x3ml)',
    category: 'Bio remodulering',
    description: 'Specifieke Profhilo behandeling voor lichaamszones zoals buik of armen.',
    price: '525',
    duration: '45 min',
    recovery: '1 dag',
    visibility: '4-8 weken',
    details: 'De bekende Profhilo technologie, maar dan specifiek ontwikkeld voor het lichaam. Met een hogere concentratie en volume (2 spuiten van 3ml) behandelen we huidverslapping aan de buik, bovenarmen of knieën. Het verstrakt de huid en verbetert de structuur.',
    benefits: ['Verstrakking van lichaamshuid', 'Pakt "kipfilets" of buikje aan', 'Groot volume (6ml totaal)'],
    process: [],
    faqs: [],
    imageUrl: PROFHILO_BODY_IMAGE,
    detailImageUrl: PROFHILO_BODY_IMAGE
  },
  {
    id: 'bio-5',
    name: 'Lanluma gelaat of hals',
    category: 'Bio remodulering',
    description: 'Krachtige collageenstimulator voor verstrakking van gelaat of hals.',
    price: '450',
    duration: '45 min',
    recovery: '2-3 dagen',
    visibility: 'Tot 2 jaar',
    details: 'Lanluma (PLLA) activeert de natuurlijke collageenproductie diep in de huid. In het gelaat of de hals zorgt dit voor een geleidelijke verstrakking en verbetering van de huidkwaliteit die tot wel 2 jaar aanhoudt.',
    benefits: ['Langdurig resultaat', 'Natuurlijke collageen aanmaak', 'Verstrakking kaaklijn/hals'],
    process: [],
    faqs: [],
    imageUrl: LANLUMA_FACE_IMAGE,
    detailImageUrl: LANLUMA_FACE_IMAGE
  },
  {
    id: 'bio-viscoderm',
    name: 'Viscoderm / zone',
    category: 'Bio remodulering',
    description: 'Hydrobooster specifiek voor dynamische lijntjes (barcode, voorhoofd).',
    price: '250',
    duration: '30 min',
    recovery: '2-3 dagen',
    visibility: '3-6 maanden',
    details: 'Viscoderm Hydrobooster heeft een dubbele werking: diepe hydratatie en een "stretching" effect op oppervlakkige rimpels. Het is de perfecte behandeling voor de zogenaamde barcode-lijntjes boven de lip, kraaienpootjes of lijnen op het voorhoofd, zonder de mimiek te bevriezen.',
    benefits: ['Strijkt fijne lijntjes glad', 'Behoud van mimiek', 'Diepe hydratatie'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'bio-prohydro',
    name: 'ProHydro',
    category: 'Bio remodulering',
    description: 'Intensieve bio-revitalisatie voor een vermoeide huid.',
    price: '475',
    duration: '30 min',
    recovery: '1 dag',
    visibility: 'Direct glow',
    details: 'Een krachtige behandeling die de huidkwaliteit een boost geeft. ProHydro werkt op hydratatie, elasticiteit en glans. Geschikt voor wie de huidconditie wil optimaliseren en preventief wil werken tegen veroudering.',
    benefits: ['Intense glow', 'Verbeterde huidstructuur', 'Preventieve anti-aging'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'bio-booster',
    name: 'BioBooster',
    category: 'Bio remodulering',
    description: 'Skinbooster voor fijne lijntjes en hydratatie.',
    price: '300',
    duration: '30 min',
    recovery: '1 dag',
    visibility: '3-6 maanden',
    details: 'De BioBooster behandeling voedt de huid van binnenuit met hyaluronzuur en essentiële nutriënten. Het resultaat is een vollere, gladdere huid met minder fijne lijntjes.',
    benefits: ['Verfijnt poriën', 'Hydrateert', 'Verzacht lijntjes'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  {
    id: 'bio-nctf',
    name: 'NCTF HA',
    category: 'Bio remodulering',
    description: 'De beroemde vitaminecocktail voor huidverbetering.',
    price: '250',
    duration: '30 min',
    recovery: 'Geen',
    visibility: 'Na kuur',
    details: 'NCTF 135 HA is een unieke cocktail van hyaluronzuur en 59 revitaliserende ingrediënten (vitaminen, aminozuren, mineralen). Het verbetert de huidkwaliteit, glans en poriestructuur aanzienlijk. Vaak toegepast via microneedling of injecties (nanosoft).',
    benefits: ['Stralende teint', 'Verfijnde poriën', 'Complexe voeding voor de huid'],
    process: [],
    faqs: [],
    imageUrl: FILLER_IMAGE,
    detailImageUrl: FILLER_IMAGE
  },
  
  // Cellboosters
  {
    id: 'cell-1',
    name: 'PRP (Vampire Facial)',
    category: 'Cellboosters',
    description: '100% natuurlijke huidverbetering met eigen bloedplasma.',
    price: '250',
    duration: '45 min',
    recovery: '1 dag',
    visibility: 'Cumulatief',
    details: 'PRP (Platelet Rich Plasma) maakt gebruik van de groeifactoren in uw eigen bloed om de huid te herstellen en verjongen. Er wordt een kleine hoeveelheid bloed afgenomen en gecentrifugeerd. Het plasma wordt vervolgens in de huid geïnjecteerd of gebruikt bij microneedling. Omdat het lichaams eigen materiaal is, is er geen risico op allergische reacties.',
    benefits: ['100% natuurlijk', 'Verbetert huidkwaliteit en textuur', 'Vermindert fijne lijntjes', 'Veilig en hypoallergeen'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'cell-ha',
    name: 'Hyaluronzuur Skinbooster',
    category: 'Cellboosters',
    description: 'Diepe hydratatie en verbetering van de huidkwaliteit.',
    price: '150 - 250',
    duration: '30 min',
    recovery: '1 dag',
    visibility: 'Na 1 week',
    details: 'Een intensieve hydratatiebehandeling met puur hyaluronzuur. Het verbetert de elasticiteit, vermindert fijne lijntjes en geeft de huid een gezonde glans zonder volume toe te voegen.',
    benefits: ['Diepe hydratatie', 'Verfijnt huidstructuur', 'Gezonde glow'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'cell-lumi',
    name: 'Lumi Eyes (Donkere kringen)',
    category: 'Cellboosters',
    description: 'Gespecialiseerde behandeling tegen donkere kringen en vermoeide ogen.',
    price: '150',
    duration: '20 min',
    recovery: '1-2 dagen',
    visibility: 'Na 1-2 sessies',
    details: 'Lumi Eyes is een krachtige weefselstimulator op basis van polynucleotiden, specifiek ontwikkeld voor de delicate huid rond de ogen. Het verheldert donkere kringen, vermindert fijne lijntjes en herstelt de huidstructuur.',
    benefits: ['Verheldert donkere kringen', 'Versterkt dunne huid', 'Frissere blik'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'cell-nctf-eye',
    name: 'NCTF Fillmed (Oogcontour)',
    category: 'Cellboosters',
    description: 'Vitaminecocktail specifiek voor de fijne huid rond de ogen.',
    price: '150',
    duration: '20 min',
    recovery: 'Geen',
    visibility: 'Direct',
    details: 'De gerenommeerde NCTF 135 HA cocktail van Fillmed wordt met uiterste precisie (vaak met Nanosoft) rond de ogen aangebracht. De mix van hyaluronzuur en 59 ingrediënten voedt de huid intensief en pakt fijne droogtelijntjes aan.',
    benefits: ['Voeding van de oogcontour', 'Veilig en pijnloos', 'Directe opfrissing'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'cell-lift',
    name: 'Cellbooster Lift',
    category: 'Cellboosters',
    description: 'Vermindert effecten van veroudering en verbetert huidtonus.',
    price: '150',
    duration: '30 min',
    recovery: '1 dag',
    visibility: 'Na kuur',
    details: 'Cellbooster Lift is een complex dat de microcirculatie en celvernieuwing stimuleert. Het verstevigt de huidbarrière en geeft een subtiel liftend effect door de huidstructuur te verdichten.',
    benefits: ['Verstevigend', 'Verbeterde microcirculatie', 'Langdurig effect'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'cell-shape',
    name: 'Cellbooster Shape',
    category: 'Cellboosters',
    description: 'Aanpak van lokaal vet en vochtophoping (bijv. onderkin/wallen).',
    price: '150',
    duration: '30 min',
    recovery: 'Lichte zwelling',
    visibility: 'Na 2-3 sessies',
    details: 'Cellbooster Shape is ontworpen om lokale vetophopingen en vochtretentie (oedeem) te verminderen. Het helpt de contouren van het gelaat, zoals de onderkin of kaaklijn, strakker en beter gedefinieerd te maken.',
    benefits: ['Vermindert lokaal vet', 'Afdrijvend effect (vocht)', 'Verbeterde contouren'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },

  // Draadjeslift APTOS
  {
    id: 'aptos-1',
    name: 'Draadjeslift Kaaklijn',
    category: 'Draadjeslift APTOS',
    description: 'Lifting van de kaaklijn zonder chirurgische ingreep.',
    price: '775',
    duration: '60 min',
    recovery: '3-7 dagen',
    visibility: '1.5 - 2 jaar',
    details: 'Een draadjeslift met APTOS draden is een minimaal invasieve methode om de gelaatscontouren te liften. De oplosbare draden met weerhaakjes worden onder de huid geplaatst om weefsel te repositioneren en de kaaklijn strakker te maken. Daarnaast stimuleren de draden de aanmaak van collageen, wat zorgt voor een langdurige versteviging van de huid.',
    benefits: ['Direct liftend effect', 'Verstrakking van de "hamsterwangen"', 'Collageen aanmaak op lange termijn', 'Geen littekens'],
    process: [
      { step: 1, title: 'Verdoving', description: 'De insteekpunten worden lokaal verdoofd.' },
      { step: 2, title: 'Plaatsing', description: 'De draden worden via een canule onder de huid geschoven en aangetrokken.' },
      { step: 3, title: 'Herstel', description: 'Enige zwelling en blauwe plekken zijn mogelijk gedurende enkele dagen.' }
    ],
    faqs: [
      { question: 'Zijn de draden voelbaar?', answer: 'In de eerste weken kunt u ze soms voelen, maar ze worden snel opgenomen in het weefsel.' },
      { question: 'Is het resultaat permanent?', answer: 'Nee, de draden lossen op na 1,5 tot 2 jaar, maar de collageenverbetering kan langer aanhouden.' }
    ],
    imageUrl: APTOS_JAW_IMAGE,
    detailImageUrl: APTOS_JAW_IMAGE
  },
  {
    id: 'aptos-2',
    name: 'Draadjeslift Jukbeenderen',
    category: 'Draadjeslift APTOS',
    description: 'Volumeherstel en lifting van de wangen voor een jeugdige V-shape.',
    price: '775',
    duration: '60 min',
    recovery: '3-7 dagen',
    visibility: '1.5 - 2 jaar',
    details: 'Naarmate we ouder worden, zakt het vetweefsel van de jukbeenderen naar beneden, wat zorgt voor een vermoeide uitstraling en diepere neus-lippenplooien. Met APTOS draden kunnen we dit weefsel subtiel terugliften naar de oorspronkelijke positie. Dit herstelt het volume op de jukbeenderen en geeft het gezicht zijn jeugdige hartvorm terug, zonder het onnatuurlijke volume van teveel fillers.',
    benefits: ['Herstel van jeugdige contouren', 'Liftend effect op de wangen', 'Natuurlijk resultaat door eigen weefselverplaatsing', 'Collageenstimulatie'],
    process: [
      { step: 1, title: 'Aftekenen', description: 'De vectoren voor de lift worden nauwkeurig op de wangen getekend.' },
      { step: 2, title: 'Plaatsing', description: 'De draden worden in het vetweefsel van de wang geplaatst en aangetrokken om het weefsel te liften.' }
    ],
    faqs: [],
    imageUrl: APTOS_CHEEK_IMAGE,
    detailImageUrl: APTOS_CHEEK_IMAGE
  },
  {
    id: 'aptos-3',
    name: 'Draadjeslift Neus-lippenplooi',
    category: 'Draadjeslift APTOS',
    description: 'Verzachten van de diepe plooi tussen neus en mond.',
    price: '775',
    duration: '45 min',
    recovery: '3-5 dagen',
    visibility: '1 - 1.5 jaar',
    details: 'Een diepe neus-lippenplooi kan u een norse of vermoeide uitdrukking geven. Waar fillers de plooi enkel opvullen, kunnen specifieke APTOS draden (zoals de Nano of Visage draden) de huid in dit gebied verstevigen en de plooi gladstrijken. Dit is vaak een mooie aanvulling op een lifting van de jukbeenderen.',
    benefits: ['Verzacht diepe groeven', 'Verstevigt de huid lokaal', 'Voorkomt verdieping van de plooi'],
    process: [],
    faqs: [],
    imageUrl: APTOS_NASOLABIAL_IMAGE,
    detailImageUrl: APTOS_NASOLABIAL_IMAGE
  },
  {
    id: 'aptos-4',
    name: 'Draadjeslift Onderkin & Hals',
    category: 'Draadjeslift APTOS',
    description: 'Verstrakking van de halslijn en reductie van de onderkin.',
    price: '775',
    duration: '60 min',
    recovery: '5-7 dagen',
    visibility: '1.5 - 2 jaar',
    details: 'Een verslapte hals of onderkin is vaak lastig te behandelen zonder chirurgie. APTOS draden bieden hier een krachtige oplossing. Door draden in een specifiek patroon onder de kin te plaatsen (het "hangmatje"), wordt de huid ondersteund en strakker getrokken. Dit definieert de kaakhoek en vermindert het zichtbare vet of de losse huid onder de kin.',
    benefits: ['Scherpere kaaklijn', 'Vermindering van onderkin', 'Verstrakking van de hals', 'Alternatief voor neklift'],
    process: [
      { step: 1, title: 'Verdoving', description: 'Lokale verdoving van het gebied onder de kin.' },
      { step: 2, title: 'Ondersteuning', description: 'Draden worden geplaatst om een steunend netwerk te vormen.' }
    ],
    faqs: [
      { question: 'Is het pijnlijk?', answer: 'De hals is een gevoelig gebied, maar met goede verdoving is de behandeling goed te verdragen. Na de behandeling kan het gebied beurs aanvoelen.' }
    ],
    imageUrl: APTOS_NECK_IMAGE,
    detailImageUrl: APTOS_NECK_IMAGE
  },
  {
    id: 'aptos-5',
    name: 'Draadjeslift Full Face',
    category: 'Draadjeslift APTOS',
    description: 'Complete non-chirurgische facelift voor het gehele gelaat.',
    price: 'Te bespreken',
    duration: '90 min',
    recovery: '7-10 dagen',
    visibility: '1.5 - 2 jaar',
    details: 'De Full Face draadjeslift is de meest uitgebreide behandeling waarbij we meerdere zones (jukbeenderen, kaaklijn, en eventueel hals) in één sessie aanpakken. Dit zorgt voor een harmonieus en compleet verjongend effect. Omdat het hele gezicht in balans wordt gelift, is het resultaat vaak natuurlijker dan wanneer slechts één zone wordt behandeld.',
    benefits: ['Totaalverjonging zonder operatie', 'Harmonieus resultaat', 'Maximale collageenboost', 'Langdurig effect'],
    process: [
      { step: 1, title: 'Consult', description: 'Uitgebreide planning van alle te behandelen zones.' },
      { step: 2, title: 'Behandeling', description: 'Plaatsing van diverse types draden afgestemd op elke zone.' },
      { step: 3, title: 'Nazorg', description: 'U draagt mogelijk een ondersteunend verband gedurende enkele dagen.' }
    ],
    faqs: [],
    imageUrl: APTOS_FULL_FACE_IMAGE,
    detailImageUrl: APTOS_FULL_FACE_IMAGE
  },
  {
    id: 'aptos-6',
    name: 'Draadjeslift Andere Zones',
    category: 'Draadjeslift APTOS',
    description: 'Wenkbrauwlift, lichaam (armen/buik) of specifieke correcties.',
    price: 'Te bespreken',
    duration: '30 - 60 min',
    recovery: 'Variabel',
    visibility: '1 - 2 jaar',
    details: 'Naast de klassieke zones kunnen APTOS draden ook gebruikt worden voor een wenkbrauwlift (Foxy Eyes), het verstrakken van de bovenarmen (kipfilets), de buik of boven de knieën. Dr. An De Cuyper bekijkt graag met u de mogelijkheden voor deze specifieke indicaties.',
    benefits: ['Maatwerk oplossingen', 'Verstrakking van lichaamshuid mogelijk', 'Subtiele correcties'],
    process: [],
    faqs: [],
    imageUrl: APTOS_BODY_IMAGE,
    detailImageUrl: APTOS_BODY_IMAGE
  },

  // Cellulite & Lichaamsverbetering
  {
    id: 'shock-1',
    name: 'Shockwave (1 sessie / zone)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Geavanceerde akoestische golftherapie voor gladdere benen en billen.',
    price: '75',
    duration: '20 min',
    recovery: 'Geen',
    visibility: 'Na kuur',
    details: 'Shockwave therapie gebruikt krachtige geluidsgolven om de bloedcirculatie en lymfedrainage te stimuleren en het bindweefsel soepeler te maken. Dit is een bewezen methode om de zichtbaarheid van cellulite te verminderen en de huid te verstevigen zonder naalden of operatie.',
    benefits: ['Pijnloze behandeling', 'Verbetert huidstructuur', 'Vermindert sinaasappelhuid', 'Stimuleert vetverbranding lokaal'],
    process: [
      { step: 1, title: 'Gel', description: 'Er wordt contactgel aangebracht op de te behandelen zone.' },
      { step: 2, title: 'Impulsen', description: 'Het apparaat geeft mechanische impulsen af op de huid.' },
      { step: 3, title: 'Herhaling', description: 'Voor goed resultaat is een kuur van 6 tot 10 sessies nodig.' }
    ],
    faqs: [],
    imageUrl: SHOCKWAVE_IMAGE,
    detailImageUrl: SHOCKWAVE_IMAGE
  },
  {
    id: 'shock-5',
    name: 'Shockwave (5 sessies / zone)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Voordelige kuur van 5 shockwave behandelingen.',
    price: '300',
    duration: '5x 20 min',
    recovery: 'Geen',
    visibility: 'Na kuur',
    details: 'Een kuur van 5 behandelingen om het resultaat van de shockwave therapie te optimaliseren. Meerdere sessies zijn nodig om het bindweefsel effectief te versoepelen en de huid te verstrakken.',
    benefits: ['Voordeliger tarief', 'Intensieve aanpak', 'Optimale resultaten'],
    process: [],
    faqs: [],
    imageUrl: SHOCKWAVE_IMAGE,
    detailImageUrl: SHOCKWAVE_IMAGE
  },
  {
    id: 'cellu-1',
    name: 'Celluerase (Sessie incl. meso)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Definitieve verwijdering van diepe cellulite putjes inclusief mesotherapie.',
    price: '400',
    duration: '45 min',
    recovery: '3-5 dagen (blauwe plekken)',
    visibility: 'Direct na herstel',
    details: 'Celluerase is een specifieke techniek waarbij met een microsurgical blade de verharde bindweefselstrengen (septa) worden losgemaakt die de huid intrekken en cellulite putjes veroorzaken. De behandeling wordt gecombineerd met mesotherapie om de huidkwaliteit verder te verbeteren en het weefsel te herstellen.',
    benefits: ['Verwijdert diepe putjes', 'Eenmalige behandeling per zone', 'Inclusief huidverbeterende meso'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'cellu-2',
    name: 'Celluerase (Meso)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Losse mesotherapie behandeling voor cellulite.',
    price: '150',
    duration: '30 min',
    recovery: '1-2 dagen',
    visibility: 'Na kuur',
    details: 'Mesotherapie voor cellulite (Alidya of vergelijkbaar) pakt de oorzaken van cellulite aan: slechte circulatie, vetophoping en toxines. Het verbetert de huidstructuur en vermindert het sinaasappelhuid-effect.',
    benefits: ['Verbetert circulatie', 'Huidverbetering', 'Aanvulling op Celluerase'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'lan-bil-1',
    name: 'Lanluma Billen (Non-Surgical Butt Lift)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Billen verstevigen en ronder maken zonder operatie.',
    price: '1750',
    duration: '60 min',
    recovery: '2-3 dagen',
    visibility: 'Na 2-3 maanden',
    details: 'Met Lanluma (PLLA) kunnen we de vorm en textuur van de billen verbeteren. Het stimuleert het lichaam om collageen aan te maken, wat zorgt voor meer volume, het opvullen van "heupdeuken" (hip dips) en een gladdere huid. Een veilig alternatief voor de Braziliaanse billift (BBL).',
    benefits: ['Natuurlijke vergroting', 'Verbetert cellulite op de billen', 'Vult hip dips op', 'Geen operatie nodig'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'lan-arms-1',
    name: 'Lanluma Armen (1 flacon)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Huidversteviging van de bovenarmen (kipfilets).',
    price: '750',
    duration: '30 min',
    recovery: '2-3 dagen',
    visibility: 'Na 2-3 maanden',
    details: 'Lanluma stimuleert de collageenaanmaak in de bovenarmen, waardoor de huid strakker en steviger wordt.',
    benefits: ['Verstrakt bovenarmen', 'Natuurlijk resultaat', 'Langdurig effect'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'lan-arms-2',
    name: 'Lanluma Armen (2 flacons)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Intensieve versteviging van de bovenarmen.',
    price: '1400',
    duration: '45 min',
    recovery: '2-3 dagen',
    visibility: 'Na 2-3 maanden',
    details: 'Dubbele dosering Lanluma voor een krachtiger resultaat bij verslapping van de bovenarmen.',
    benefits: ['Krachtige verstrakking', 'Betere contouren', 'Langdurig effect'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'lan-stomach-1',
    name: 'Lanluma Buik (1 flacon)',
    category: 'Cellulite & Lichaamsverbetering',
    description: 'Versteviging van de huid op de buik.',
    price: '750',
    duration: '30 min',
    recovery: '2-3 dagen',
    visibility: 'Na 2-3 maanden',
    details: 'Behandeling van huidverslapping op de buik, bijvoorbeeld na zwangerschap of gewichtsverlies, door middel van collageenstimulatie.',
    benefits: ['Verstrakt buikhuid', 'Verbetert huidstructuur', 'Natuurlijke opbouw'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },

  // CO2 Laser
  {
    id: 'co2-4',
    name: 'CO2 Laser Resurfacing Full Face',
    category: 'CO2 Laser',
    description: 'De gouden standaard voor huidvernieuwing en littekencorrectie.',
    price: '1250',
    duration: '60 min',
    recovery: '7-10 dagen',
    visibility: 'Jaren',
    details: 'De fractionele CO2 laser maakt duizenden microscopische gaatjes in de huid, waardoor het oude weefsel wordt afgestoten en vervangen door nieuwe, frisse huid. Dit is de meest effectieve behandeling voor diepe rimpels, zonneschade, grove poriën en (acne)littekens. Het resultaat is een dramatische verbetering van de huidstructuur.',
    benefits: ['Verwijdert pigmentvlekken', 'Verstrakking van de huid', 'Vervlakt littekens', 'Langdurig resultaat'],
    process: [
      { step: 1, title: 'Voorbereiding', description: 'De huid wordt een uur op voorhand ingesmeerd met sterke verdovende crème.' },
      { step: 2, title: 'Laser', description: 'De laserbehandeling zelf duurt ongeveer 20-30 minuten en voelt warm aan.' },
      { step: 3, title: 'Nazorg', description: 'De huid zal rood zijn en vervellen. Goede nazorg met voorgeschreven crèmes is cruciaal.' }
    ],
    faqs: [
      { question: 'Is het pijnlijk?', answer: 'Met de juiste verdoving is het goed te doen, maar u voelt wel warmte en prikkeling.' },
      { question: 'Kan dit in de zomer?', answer: 'Nee, door het risico op pigmentatie voeren we deze behandeling enkel uit in de herfst en winter.' }
    ],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  {
    id: 'co2-2',
    name: 'Oogleden (niet-chirurgische blepharoplastie)',
    category: 'CO2 Laser',
    description: 'Verstrakking van de oogleden zonder snijden.',
    price: '550 - 750',
    duration: '45 min',
    recovery: '5-7 dagen',
    visibility: 'Langdurig',
    details: 'Voor lichte tot matige huidverslapping van de oogleden is de CO2 laser een uitstekend alternatief voor chirurgie. De laser verdampt de overtollige huid en verststrakt het onderliggende weefsel, wat zorgt voor een open en frisse blik zonder littekens van een operatie.',
    benefits: ['Geen snijwonden of hechtingen', 'Korte hersteltijd', 'Verbetert ook de huidkwaliteit rond de ogen'],
    process: [],
    faqs: [],
    imageUrl: CO2_EYE_IMAGE,
    detailImageUrl: CO2_EYE_IMAGE
  },
  {
    id: 'co2-peel',
    name: 'Laserpeeling',
    category: 'CO2 Laser',
    description: 'Lichtere laserbehandeling voor opfrissing en glans (zonder lange downtime).',
    price: '350',
    duration: '30 min',
    recovery: '3-5 dagen roodheid',
    visibility: 'Na 1 week',
    details: 'Een laserpeeling of "Cool Peel" verwijdert de dode toplaag van de huid en stimuleert de celvernieuwing. Het is minder ingrijpend dan een diepe resurfacing, waardoor de hersteltijd korter is. Ideaal voor het verfijnen van poriën en een frisse "glow".',
    benefits: ['Verfijnt poriën', 'Frisse teint', 'Korte hersteltijd'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  {
    id: 'co2-hands',
    name: 'Resurfacing handen',
    category: 'CO2 Laser',
    description: 'Verjonging van de handen en verwijderen van pigmentvlekken.',
    price: '350 - 450',
    duration: '30 min',
    recovery: '1 week',
    visibility: 'Na genezing',
    details: 'Handen verraden vaak de leeftijd door pigmentvlekken en dunner wordende huid. De CO2 laser pakt deze zonneschade effectief aan en verstrakt de huid van de handrug.',
    benefits: ['Verwijdert ouderdomsvlekken', 'Verbetert huidstructuur', 'Verjongt de handen'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  {
    id: 'co2-face-neck',
    name: 'Resurfacing gelaat & hals',
    category: 'CO2 Laser',
    description: 'Gecombineerde diepe behandeling voor gelaat en hals.',
    price: '1500',
    duration: '90 min',
    recovery: '7-10 dagen',
    visibility: 'Jaren',
    details: 'Door gelaat en hals in één sessie te behandelen, zorgt u voor een naadloze overgang en een algehele verjonging. De hals toont vaak sneller verslapping; de CO2 laser stimuleert hier krachtig de collageenaanmaak.',
    benefits: ['Uniform resultaat', 'Aanpak huidverslapping hals', 'Totale vernieuwing'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  {
    id: 'co2-total',
    name: 'Resurfacing gelaat/hals/decolleté',
    category: 'CO2 Laser',
    description: 'De meest complete aanpak voor zonneschade en veroudering.',
    price: '1750',
    duration: '120 min',
    recovery: '7-14 dagen',
    visibility: 'Jaren',
    details: 'Deze behandeling pakt de drie zones aan die het meest blootgesteld worden aan de zon. Het verwijdert pigmentatie, rimpels en littekens op gelaat, hals en decolleté voor een compleet verjongde uitstraling.',
    benefits: ['Maximale verjonging', 'Verwijdert zonneschade op decolleté', 'Egaliseert de huidskleur'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  
  // Laser (Pigment & Vaatletsels)
  {
    id: 'laser-pigment',
    name: 'Pigment',
    category: 'Laser',
    description: 'Effectieve verwijdering van pigmentvlekken en zonneschade.',
    price: '150 - 250',
    duration: '30 min',
    recovery: 'Lichte roodheid',
    visibility: 'Na 1-2 sessies',
    details: 'Storende pigmentvlekken, ouderdomsvlekken (lentigo) of zonschade kunnen effectief behandeld worden met lasertherapie. De laserenergie breekt het pigment af, waarna het lichaam dit opruimt.',
    benefits: ['Egale teint', 'Verwijdert ouderdomsvlekken', 'Veilig en effectief'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  {
    id: 'laser-vaat',
    name: 'Vaatletsels',
    category: 'Laser',
    description: 'Behandeling van couperose, rode vaatjes en spinnaevi.',
    price: '150 - 250',
    duration: '15 - 30 min',
    recovery: 'Lichte roodheid',
    visibility: 'Direct tot 4 weken',
    details: 'Verwijde bloedvaatjes in het gelaat (couperose) of spinnaevi kunnen cosmetisch storend zijn. Met de vasculaire laser worden deze vaatjes selectief verhit en gesloten, zonder de omliggende huid te beschadigen.',
    benefits: ['Verwijdert roodheid', 'Behandelt couperose', 'Egalere huid'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },

  // Microneedling
  {
    id: 'mn-1',
    name: 'Infini RF Microneedling',
    category: 'Microneedling',
    description: 'Geavanceerde combinatie van microneedling en radiofrequentie.',
    price: '250 - 650',
    duration: '60 min',
    recovery: '1-3 dagen',
    visibility: 'Na kuur',
    details: 'Infini RF combineert twee technologieën: micronaaldjes die de huid penetreren en radiofrequente energie die diep in de lederhuid warmte afgeeft. Dit zorgt voor een krachtige stimulatie van collageen en elastine, zonder de opperhuid te beschadigen. Zeer effectief voor huidverstrakking, acne littekens en grove poriën.',
    benefits: ['Geschikt voor alle huidtypes (ook donkere huid)', 'Korte downtime', 'Diepe werking in de huid', 'Effectief tegen littekens'],
    process: [],
    faqs: [
      { question: 'Hoeveel sessies zijn nodig?', answer: 'Gemiddeld zijn 3 behandelingen nodig met 4 weken interval.' }
    ],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },

  // Lipolyse
  {
    id: 'lip-1',
    name: 'Lipolyse (Vet weg prik)',
    category: 'Lipolyse',
    description: 'Verwijderen van lokaal vet (zoals onderkin) met injecties.',
    price: '195',
    duration: '30 min',
    recovery: 'Zwelling (1 week)',
    visibility: 'Na enkele weken',
    details: 'Lipolyse is een methode om hardnekkige vetophopingen te verwijderen die niet verdwijnen met sporten of dieet. Een vloeistof wordt in het vetweefsel geïnjecteerd, waardoor de vetcellen afbreken en op natuurlijke wijze door het lichaam worden afgevoerd. Ideaal voor de onderkin of kleine vetrolletjes.',
    benefits: ['Definitieve verwijdering van vetcellen', 'Verbetering van contouren', 'Geen operatie of littekens'],
    process: [
      { step: 1, title: 'Injectie', description: 'De werkzame stof wordt met dunne naaldjes in het vetweefsel gebracht.' },
      { step: 2, title: 'Reactie', description: 'Er ontstaat zwelling en roodheid; dit is een teken dat het proces werkt.' },
      { step: 3, title: 'Afvoer', description: 'Het lichaam voert de afgebroken vetcellen in de komende weken af.' }
    ],
    faqs: [
      { question: 'Komt het vet terug?', answer: 'Nee, verwijderde vetcellen komen niet terug. Wel kan bij gewichtstoename het resterende vet in volume toenemen.' }
    ],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },

  // Handen
  {
    id: 'hands-rejuvenation',
    name: 'Verjongingspakket laser met Radiesse/Profhilo',
    category: 'Handen',
    description: 'Complete verjonging van de handen.',
    price: '550',
    duration: '45 min',
    recovery: '3-5 dagen',
    visibility: 'Langdurig',
    details: 'Een gecombineerde aanpak voor de handen: laserbehandeling voor huidverbetering en pigmentvlekken, gecombineerd met Radiesse of Profhilo voor volumeherstel en hydratatie.',
    benefits: ['Egalere huid', 'Volumeherstel', 'Jeugdige uitstraling handen'],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE, 
    detailImageUrl: LASER_IMAGE
  },

  // Tandenknarsen
  {
    id: 'brux-1',
    name: 'Behandeling Tandenknarsen (Bruxisme)',
    category: 'Tandenknarsen',
    description: 'Ontspanning van de kaakspieren om tandenknarsen te stoppen.',
    price: '250 - 350',
    duration: '15 min',
    recovery: 'Geen',
    visibility: '3-6 maanden',
    details: 'Overmatige spanning op de kaakspieren (masseter) kan leiden tot tandenknarsen, hoofdpijn en een brede, hoekige kaaklijn. Door deze spieren te behandelen met spierontspanners, vermindert de spanning aanzienlijk. Dit beschermt uw gebit, verlicht pijnklachten en kan als esthetisch voordeel het gezicht slanker maken ("Face Slimming").',
    benefits: ['Stopt tandenknarsen/klemmen', 'Vermindert spanningshoofdpijn', 'Versmalt de kaaklijn (V-shape)', 'Beschermt het gebit tegen slijtage'],
    process: [],
    faqs: [],
    imageUrl: BOTOX_IMAGE,
    detailImageUrl: BOTOX_IMAGE
  },

  // Hydrafacial
  {
    id: 'hydra-1',
    name: 'Hydrafacial Signature',
    category: 'Hydrafacial',
    description: 'Dieptereiniging en hydratatie voor een stralende huid.',
    price: '150',
    duration: '30 min',
    recovery: 'Geen',
    visibility: 'Direct',
    details: 'HydraFacial is een wereldwijd geliefde behandeling die de huid reinigt, exfolieert en hydrateert in één sessie. Met behulp van vortex-technologie worden onzuiverheden uit de poriën gezogen terwijl de huid wordt gevoed met serums vol antioxidanten en hyaluronzuur. Het resultaat is een direct schone, gladde en stralende huid ("The HydraFacial Glow").',
    benefits: ['Diepe reiniging van poriën', 'Verwijdert dode huidcellen', 'Directe glow zonder irritatie', 'Ideaal voor een evenement'],
    process: [
      { step: 1, title: 'Reiniging', description: 'Zachte exfoliatie en peeling van de huid.' },
      { step: 2, title: 'Extractie', description: 'Pijnloze verwijdering van onzuiverheden uit de poriën.' },
      { step: 3, title: 'Hydratatie', description: 'Insluisen van intensieve serums.' }
    ],
    faqs: [
      { question: 'Is het geschikt voor de gevoelige huid?', answer: 'Ja, HydraFacial is zacht en geschikt voor bijna alle huidtypes.' }
    ],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'hydra-deluxe',
    name: 'Hydrafacial Deluxe',
    category: 'Hydrafacial',
    description: 'De Signature behandeling uitgebreid met specifieke boosters en LED-therapie.',
    price: '175',
    duration: '45 min',
    recovery: 'Geen',
    visibility: 'Direct',
    details: 'Een upgrade van de Signature behandeling. Naast de dieptereiniging wordt de huid behandeld met een specifieke booster afgestemd op uw huidbehoeften (bijv. pigmentatie, fijn lijntjes) en sluiten we af met LED-lichttherapie voor optimaal resultaat.',
    benefits: ['Diepe reiniging', 'Booster op maat', 'LED-lichttherapie', 'Extra glow'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'hydra-perk',
    name: 'Perk lippen of ogen (Add-on)',
    category: 'Hydrafacial',
    description: 'Extra verzorging voor de gevoelige zones tijdens uw Hydrafacial.',
    price: '+ 30',
    duration: '+ 10 min',
    recovery: 'Geen',
    visibility: 'Direct',
    details: 'Perk is een revitaliserende behandeling voor de ogen of lippen die kan worden toegevoegd aan uw Hydrafacial. Het verfrist de oogcontouren of maakt de lippen voller en zachter. U krijgt het resterende serum mee naar huis.',
    benefits: ['Focus op probleemzones', 'Directe verfrissing', 'Inclusief take-home serum'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  
  // Haarverlies
  {
    id: 'hair-1',
    name: 'PRP Haar',
    category: 'Haarverlies',
    description: 'Stop haaruitval en stimuleer nieuwe haargroei.',
    price: '250',
    duration: '45 min',
    recovery: 'Geen',
    visibility: 'Na kuur',
    details: 'PRP injecties in de hoofdhuid stimuleren de haarzakjes door de hoge concentratie groeifactoren. Dit kan haaruitval vertragen, de haardos verdikken en de gezondheid van de hoofdhuid verbeteren. Effectief bij beginnende kaalheid of dunner wordend haar bij zowel mannen als vrouwen.',
    benefits: ['Remt haaruitval', 'Maakt haren dikker en sterker', 'Natuurlijke methode'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'hair-filler-1',
    name: 'Haarfiller 1 ml',
    category: 'Haarverlies',
    description: 'Peptiden-complex voor hergroei en verdikking van het haar.',
    price: '195',
    duration: '30 min',
    recovery: 'Geen',
    visibility: 'Na kuur',
    details: 'Haarfillers bevatten een uniek complex van peptiden en hyaluronzuur. Ze remmen het haaruitvalproces en stimuleren de hergroei door de bloedcirculatie en de haarzakjes te revitaliseren. Ideaal voor dunner wordend haar.',
    benefits: ['Remt haaruitval', 'Stimuleert hergroei', 'Verbetert hoofdhuidkwaliteit'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'hair-filler-2',
    name: 'Haarfiller 2 ml',
    category: 'Haarverlies',
    description: 'Dubbele dosis haarfiller voor een groter behandelgebied.',
    price: '350',
    duration: '30 min',
    recovery: 'Geen',
    visibility: 'Na kuur',
    details: 'Voor een uitgebreidere zone of intensievere behandeling kan een dubbele dosis haarfiller (2ml) worden ingezet. Dit zorgt voor een krachtigere stimulatie van de haarzakjes over een groter oppervlak.',
    benefits: ['Groter behandelgebied', 'Intensieve voeding', 'Kostenefficiënter'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },

  {
    id: 'dissolve-1',
    name: 'Oplossen Filler (Hyalase)',
    category: 'Oplossen Filler',
    description: 'Correctie van eerdere fillerbehandelingen.',
    price: 'Vanaf 75',
    duration: '15 min',
    recovery: 'Zwelling',
    visibility: '24 uur',
    details: 'Bent u niet tevreden over een fillerbehandeling elders, of is er sprake van migratie of asymmetrie? Met Hyalase (hyaluronidase) kunnen we hyaluronzuur fillers veilig en snel oplossen. Het enzym breekt de filler binnen 24 uur af, waarna de oorspronkelijke situatie hersteld wordt.',
    benefits: ['Snelle correctie', 'Veilig', 'Voorkomt langdurige ongewenste resultaten'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'surg-1',
    name: 'Chirurgische verwijdering huidletsels',
    category: 'Chirurgie',
    description: 'Verwijderen van moedervlekken, cysten of lipomen.',
    price: '150 - 250',
    duration: '30 min',
    recovery: '1-2 weken',
    visibility: 'Definitief',
    details: 'Dr. An De Cuyper verwijdert op deskundige wijze storende of medisch verdachte huidletsels (zoals moedervlekken, cysten of vetbultjes) onder lokale verdoving. Er wordt gestreefd naar een zo minimaal mogelijk litteken.',
    benefits: ['Medisch verantwoorde verwijdering', 'Esthetische hechting', 'Mogelijkheid tot weefselonderzoek'],
    process: [],
    faqs: [],
    imageUrl: DEFAULT_IMAGE,
    detailImageUrl: DEFAULT_IMAGE
  },
  {
    id: 'co2-7',
    name: 'Acne littekens gelaat',
    category: 'CO2 Laser',
    description: 'Effectieve aanpak van restlittekens na acne.',
    price: '800 - 1250',
    duration: '60 min',
    recovery: '5-7 dagen',
    visibility: 'Blijvend',
    details: 'Acne kan vervelende putjes en littekens achterlaten. De CO2 laser vlakt de randen van deze littekens af en stimuleert de huid om "van binnenuit" op te vullen met nieuw collageen. Dit maakt de huidstructuur aanzienlijk gladder en egaler.',
    benefits: [],
    process: [],
    faqs: [],
    imageUrl: LASER_IMAGE,
    detailImageUrl: LASER_IMAGE
  },
  
  // Transpiratie
  {
    id: 'sweat-mild',
    name: 'Matig zweten',
    category: 'Transpiratie',
    description: 'Behandeling voor matige transpiratie.',
    price: '300',
    duration: '30 min',
    recovery: 'Geen',
    visibility: '6-9 maanden',
    details: 'Behandeling met spierontspanners om overmatige transpiratie (hyperhidrose) tegen te gaan. Geschikt voor matige klachten.',
    benefits: ['Droge oksels', 'Geen geurtjes', 'Meer zelfvertrouwen'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'sweat-moderate',
    name: 'Opmerkelijk zweten',
    category: 'Transpiratie',
    description: 'Behandeling voor duidelijke transpiratieproblemen.',
    price: '390',
    duration: '30 min',
    recovery: 'Geen',
    visibility: '6-9 maanden',
    details: 'Een intensievere dosering voor wie last heeft van opmerkelijk veel transpiratie. Blokkeert de zweetklieren effectief.',
    benefits: ['Effectief bij zichtbare zweetplekken', 'Langdurig resultaat', 'Veilig'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  },
  {
    id: 'sweat-severe',
    name: 'Overdadig zweten',
    category: 'Transpiratie',
    description: 'Krachtige behandeling voor ernstige hyperhidrose.',
    price: '490',
    duration: '30 min',
    recovery: 'Geen',
    visibility: '6-9 maanden',
    details: 'De maximale dosering voor overdadige transpiratie die het dagelijks leven beïnvloedt.',
    benefits: ['Maximale droogte', 'Voor ernstige klachten', 'Verbetering levenskwaliteit'],
    process: [],
    faqs: [],
    imageUrl: BODY_IMAGE,
    detailImageUrl: BODY_IMAGE
  }
];

export const INITIAL_LOCATIONS: PracticeLocation[] = [
  {
    id: 'loc-burcht',
    name: 'Burcht - Linkeroever',
    address: 'Koningin Astridlaan 1E, 2070 Burcht',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Koningin+Astridlaan+1E,+Burcht'
  },
  {
    id: 'loc-edegem',
    name: 'Edegem',
    address: 'Boniverlei 174 bus 8, 2650 Edegem',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Boniverlei+174+bus+8,+Edegem'
  },
  {
    id: 'loc-hoboken',
    name: 'Hoboken',
    address: 'Steynstraat 17, 2660 Hoboken',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Steynstraat+17,+Hoboken'
  },
  {
    id: 'loc-antwerpen',
    name: 'Antwerpen',
    address: 'Binnenvaartstraat 95, 2000 Antwerpen',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Binnenvaartstraat+95,+Antwerpen'
  }
];

export const INITIAL_SETTINGS: SiteSettings = {
  logoUrl: 'https://res.cloudinary.com/dbtohvvbj/image/upload/v1766172553/Logo_black2_rf4kua.png',
  clinicName: 'MD An De Cuyper',
  heroTitle: 'Natuurlijke Schoonheid Wetenschappelijke Precisie',
  heroSubtitle: 'Uw specialist in esthetische geneeskunde en huidverbetering.',
  phone: '+32 3 284 45 39',
  email: 'info@drdecuyperan.be',
  instagram: 'https://instagram.com/dran.decuyper',
  facebook: '',
  footerText: 'Medische esthetiek met een persoonlijke aanpak.',
  bookingUrl: 'https://schedule.clinicminds.com/services?clinic=8f3592ed-f97e-11e9-9173-06f92916377c&hide-logo&l=nl-NL',
  navbarColor: '#000000',
  adminUsername: 'admin',
  adminPassword: 'password'
};
